import { render, staticRenderFns } from "./rightFixed.vue?vue&type=template&id=9a5e518c&scoped=true&"
import script from "./rightFixed.vue?vue&type=script&lang=js&"
export * from "./rightFixed.vue?vue&type=script&lang=js&"
import style0 from "./rightFixed.vue?vue&type=style&index=0&id=9a5e518c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5e518c",
  null
  
)

export default component.exports